export default __webpack_public_path__ + "static/media/IMG_5569.5dc7f930.jpg";